<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">产品</a>
        </li>
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">免费产品</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">免费虚拟主机</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="th-panel-title">免费虚拟主机</div>
      </div>
      <div class="freevhost-header ub-box">
        <div class="header-left ub-box ub-ver ub-ver-v">
          <div class="header-left-icon"></div>
        </div>
        <div class="header-right">
          <p>优点：开通即用、永久免费、BGP多线路、送免备案服务。</p>
          <p>缺点：免费虚拟主机在稳定性上没有收费产品好，建议商用用户使用收费产品。
            <a class="z-color-a" target="_blank" href="/free">了解更多产品详情></a>
          </p>
          <el-button v-if="num === 0" type="primary" @click="vhostInit" class="z-margin-top-20-precent">立即开通</el-button>
          <el-button v-if="num === 1" type="primary" @click="Manage" class="z-margin-top-20-precent">管理面板</el-button>
        </div>
      </div>
      <div class="panel-body clearfix">
        <div style="padding: 30px 108px 0 0;" v-if="num === 0">
          <div class="Z-hr"></div>
          <div class="z-margin-top-20-precent goodness">
            <div class="se-panel-title ub-box">
              免费虚拟主机优势：
            </div>
            <el-row class="z-margin-top-10-precent">
              <el-col :span="6">
                <div class="grid-content">
                  <div class="ub-box ub-ver-h z-margin-top-30-precent">
                    <div class="goodness-icon icon-01"></div>
                  </div>
                  <div class="ub-box ub-ver-h z-margin-v-20-precent">
                    <h4 class="z-font-size-16 z-color-h4">BGP多线路空间</h4>
                  </div>
                  <div class="ub-box ub-ver-h">
                    <p class="z-lineHeight-20 z-color-muted">BGP多线路空间</p>
                  </div>
                  <div class="ub-box ub-ver-h">
                    <p class="z-lineHeight-20 z-color-muted">全国各地都可以快速访问</p>
                  </div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content">
                  <div class="ub-box ub-ver-h z-margin-top-30-precent">
                    <div class="goodness-icon icon-02"></div>
                  </div>
                  <div class="ub-box ub-ver-h z-margin-v-20-precent">
                    <h4 class="z-font-size-16 z-color-h4">永久免费</h4>
                  </div>
                  <div class="ub-box ub-ver-h">
                    <p class="z-lineHeight-20 z-color-muted">在线开通，即用使用</p>
                  </div>
                  <div class="ub-box ub-ver-h">
                    <p class="z-lineHeight-20 z-color-muted">永久免费使用，全程不需要费用</p>
                  </div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content">
                  <div class="ub-box ub-ver-h z-margin-top-30-precent">
                    <div class="goodness-icon icon-03"></div>
                  </div>
                  <div class="ub-box ub-ver-h z-margin-v-20-precent">
                    <h4 class="z-font-size-16 z-color-h4">送免备案服务</h4>
                  </div>
                  <div class="ub-box ub-ver-h">
                    <p class="z-lineHeight-20 z-color-muted">免费赠送免备案服务</p>
                  </div>
                  <div class="ub-box ub-ver-h">
                    <p class="z-lineHeight-20 z-color-muted">没有备案的域名也可以使用</p>
                  </div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content">
                  <div class="ub-box ub-ver-h z-margin-top-30-precent">
                    <div class="goodness-icon icon-04"></div>
                  </div>
                  <div class="ub-box ub-ver-h z-margin-v-20-precent">
                    <h4 class="z-font-size-16 z-color-h4">十八年行业经验</h4>
                  </div>
                  <div class="ub-box ub-ver-h">
                    <p class="z-lineHeight-20 z-color-muted">拥有十八年的行业经验</p>
                  </div>
                  <div class="ub-box ub-ver-h">
                    <p class="z-lineHeight-20 z-color-muted">创始团队在云服务器行业遨游十八年</p>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div v-if="num === 1">
          <div class="freevhost-table">
            <el-row type="flex" align="middle" class="row-border" style="border-top: 1px solid #eee;background-color: #f7f9fb;border-left: 1px solid #eee;">
              <el-col :sm="6" :md="4" :lg="3" style="margin-right: -2px;">
                <div class="grid-content z-textAlign-center z-color-636 z-font-weight-700">网站域名 :</div>
              </el-col>
              <el-col :sm="18" :md="20" :lg="21" style="background-color: #fff;border-left: 1px solid #eee;">
                <div class="grid-content z-padding-left-25-precent z-margin-bottom-5-precent">
                  <p class="z-lineHeight-18 z-margin-top-5-precent"><a class="z-color-a a-underline-link" :href="'http://'+ vhostList.domainname0" target="_blank">http://{{vhostList.domainname0}}</a></p>
                  <p class="z-lineHeight-18" v-if="option.id != 0 && index < 2" v-for="(option,index) in vhostList.domainname">
                    <a class="z-color-a a-underline-link" :href="'http://'+ option.DomainName" target="_blank">http://{{option.DomainName}}</a>
                    <span v-if="option.beian == 0" style="background-color: #ff6600;color: #fff;padding: 0 2px;">免备案</span>
                  </p>
                </div>
              </el-col>
            </el-row>
            <el-row type="flex" align="middle" class="row-border">
              <el-col :sm="6" :md="4" :lg="3">
                <div class="grid-content grid-content-left z-textAlign-center z-color-636 z-font-weight-700" style="line-height: 70px;">网站配置 :</div>
              </el-col>
              <el-col :sm="18" :md="20" :lg="21">
                <div class="grid-content-small z-padding-left-25-precent">
                  <el-row>
                    <el-col :span="6">网站空间：<span class="z-color-green z-font-weight-700">{{vhostList.websize}}</span></el-col>
                    <el-col :span="6">IP地址：<span class="z-color-green z-font-weight-700">{{vhostList.ip}}</span></el-col>
                    <el-col :span="6">MySql数据库：<span class="z-color-green z-font-weight-700">{{vhostList.mysql}}</span></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">语言环境：<span class="z-color-green z-font-weight-700">{{vhostList.system}}</span></el-col>
                    <el-col :span="6">月流量：<span class="z-color-green z-font-weight-700">{{vhostList.netsize}}</span></el-col>
                    <el-col :span="6">MsSql数据库：<span class="z-color-green z-font-weight-700">{{vhostList.mssql}}</span></el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
            <el-row type="flex" align="middle" class="row-border">
              <el-col :sm="6" :md="4" :lg="3"><div class="grid-content grid-content-left z-textAlign-center z-color-636 z-font-weight-700">开通时间 :</div></el-col>
              <el-col :sm="18" :md="20" :lg="21">
                <div class="grid-content z-padding-left-25-precent">
                  {{vhostList.StartTime}}
                </div>
              </el-col>
            </el-row>
            <el-row type="flex" align="middle" class="row-border">
              <el-col :sm="6" :md="4" :lg="3">
                <div class="grid-content grid-content-left z-textAlign-center z-color-636 z-font-weight-700 z-font-size-13" style="line-height: 60px;">到期时间 :</div></el-col>
              <el-col :xs="8" :sm="8" :md="8" :lg="6">
                <div class="grid-content z-padding-left-25-precent" style="line-height: 30px;">
                  <el-row>
                    <el-col>{{vhostList.EndTime}}</el-col>
                    <el-col class="z-color-red">剩余{{vhostList.left_time}}</el-col>
                  </el-row>
                </div>
              </el-col>
              <el-col :xs="10" :sm="10" :md="12" :lg="{span:15,pull:2}">
                <div class="grid-content" style="line-height: 60px;">
                  <el-button type="primary" @click="Delay" class="z-margin-left-15-precent">免费延期</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="freevhost-help">
            <div class="se-panel-title ub-box">
              相关帮助：
            </div>
            <el-row :gutter="120">
              <el-col :span="12" v-for="(item,index) in gonggaoList" :key="item.id" v-if="item.title && index<2">
                <div class="notice-list-panel ub-box">
                  <ul class="z-width-100-precent">
                    <li class="ub-box ub-between">
                <span class="notice-content z-oneline-overflow-hidden">
                  <span class="list-decoration-point">•</span>
                  <a :href="'/help/content_'+ item.id +'.html'" :title="item.title" target="_blank">{{item.title}}</a>
                </span>
                      <span class="z-color-999">
                  {{item.setdate.split(' ')[0]}}
								</span>
                    </li>
                  </ul>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="120">
              <el-col :span="12" v-for="(item,index) in gonggaoList" :key="item.id" v-if="item.title && index>1 && index<4">
                <div class="notice-list-panel ub-box">
                  <ul class="z-width-100-precent">
                    <li class="ub-box ub-between">
                <span class="notice-content z-oneline-overflow-hidden">
                  <span class="list-decoration-point">•</span>
                  <a :href="'/help/content_'+ item.id +'.html'" :title="item.title" target="_blank">{{item.title}}</a>
                </span>
                      <span class="z-color-999">
                  {{item.setdate.split(' ')[0]}}
								</span>
                    </li>
                  </ul>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="120">
              <el-col :span="12" v-for="(item,index) in gonggaoList" :key="item.id" v-if="item.title && index>3 && index<6">
                <div class="notice-list-panel ub-box">
                  <ul class="z-width-100-precent">
                    <li class="ub-box ub-between">
                <span class="notice-content z-oneline-overflow-hidden">
                  <span class="list-decoration-point">•</span>
                  <a :href="'/help/content_'+ item.id +'.html'" :title="item.title" target="_blank">{{item.title}}</a>
                </span>
                      <span class="z-color-999">
                  {{item.setdate.split(' ')[0]}}
								</span>
                    </li>
                  </ul>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="120">
              <el-col :span="12" v-for="(item,index) in gonggaoList" :key="item.id" v-if="item.title && index>5 && index<8">
                <div class="notice-list-panel ub-box">
                  <ul class="z-width-100-precent">
                    <li class="ub-box ub-between">
                <span class="notice-content z-oneline-overflow-hidden">
                  <span class="list-decoration-point">•</span>
                  <a :href="'/help/content_'+ item.id +'.html'" :title="item.title" target="_blank">{{item.title}}</a>
                </span>
                      <span class="z-color-999">
                  {{item.setdate.split(' ')[0]}}
								</span>
                    </li>
                  </ul>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <xdialog-loading :dialogLoading="dialogLoading"></xdialog-loading>
        <!--blackpink-->
        <div v-if="dialogShadow" class="dialogShadow"></div>
        <dl v-if="dialogShadow" class="dialogBody ub-box ub-col">
          <dd class="dialogTitle z-font-size-16">
            <span class="z-font-size-18 z-padding-left-10-precent">提示信息</span>
            <a class="aui_close" href="javascript:;" @click="clickBtn()">×</a>
          </dd>
          <dd class="dialogContent z-color-666 z-font-size-15 ">
            <img style="margin-left: 30px;margin-right: 30px;vertical-align: middle" src="../../assets/imgs/uc_warn.png" alt="">
            <span class="z-font-size-15" >您的帐户还没有绑定微信</span>
            <br>
            <router-link to="/weixin" class="z-color-a z-font-size-15" style="display: inline-block;margin-left: 127px">点击这里绑定微信</router-link>
          </dd>
          <div class="dialogFooter ub-f1 ub-box ub-ver z-padding-v-15-precent">
            <!--<dd class="confirmBtn z-relative z-color-fff z-curPonit" @click="clickBtn(true)" style="background:#2ebace;">确认</dd>
            <dd class="confirmBtn z-relative z-color-fff z-curPonit" @click="clickBtn(false)" style="">取消</dd>-->
          </div>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
  import vhostService from 'business/vhostService.js'
  import XdialogLoading from 'components/commons/XdialogLoading.vue'
  import helpService from 'business/helpService.js'
  import {mapGetters,mapActions} from 'vuex'
    export default {
      data () {
        return {
          num:Number,
          listLoading:false,
          dialogLoading:false,
          dialogShadow:false,
          vhostList:[],
          gonggaoList: [],
          count:10,
          total:0,
          page:1,
        }
      },
      components:{
        XdialogLoading
      },
      props:{
        hide:Boolean
      },
      /*created() {
        this.timer = setInterval(() => {
          this.getTime()
        }, 1000)
      },*/
      mounted() {
        this.VhostQuery()
        this.getGonggao()
      },
      /*beforeDestroy() {
        if(this.timer) { //如果定时器还在运行 或者直接关闭，不用判断
          clearInterval(this.timer); //关闭
        }
      },*/
      methods:{
        ...mapActions(['DELAY']),
        async VhostQuery() {
          this.listLoading = true
          let data = 'cmd=free_vhost_list'
          let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
          if(vueData.response == 200 ) {
            this.num = vueData.num
            this.vhostList = vueData.msg
            this.vhostList.domainname0 = [...vueData.msg.domainname.filter(item => '0' === item.id)][0].DomainName
            this.listLoading = false
          }else {
            this.listLoading = false
            this.dialogWarning = true
            this.warningMsg = vueData.msg
          }
        },
        async getGonggao() {
          let {vueData, state} = await helpService.transformToVue('helpInfo','POST','cmd=query&type_id=265')
          if(vueData.response==200){
            this.gonggaoList = vueData.msg.content
          }else {
            this.$toast({tip:'请刷新页面...',type:'3'})
          }
        },
        async getTime() {
          let data = 'cmd=free_vhost_list'
          let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
          if(vueData.response == 200 ) {
            this.vhostList.left_time = vueData.msg.left_time
          }else {
            this.$toast(vueData.msg,'fail')
          }
        },
        async vhostInit() {
          this.dialogLoading = true
          let data = 'cmd=free_vhost_init'
          let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
          if(vueData.response == 200 ) {
            this.dialogLoading = false
            let self = this
            this.$dialog({type:'success', info: vueData.msg, click () {self.VhostQuery()}})
          }else {
            this.dialogLoading = false
            if(vueData.msg === 'wx_no_bind'){
              this.dialogShadow = true
            }else {
              this.$dialog({type:'error', info: vueData.msg, click () {}})
            }
          }
        },
        Manage() {
          this.DELAY('first')
          this.$router.push('/freeVhost/'+ this.vhostList.id)
        },
        Delay() {
          this.DELAY('five')
          this.$router.push('/freeVhost/'+ this.vhostList.id)
        },
        clickBtn() {
          this.dialogShadow = false
        }
      }
    }
</script>

<style scoped>
  .hideleft { margin-left: 80px; }
  .freevhost-header {
    height: 96px;
    margin-top: 18px;
    margin-bottom: 10px;
  }
  /*.page-main {
    min-height: calc(100vh - 150px);
  }*/
  .header-left {
    height: 96px;
    width: 96px;
    background-color: #00AAFF;
  }
  .header-left-icon {
    width: 59px;
    height: 58px;
    background: url(../../assets/imgs/freevhost.png) no-repeat;
  }
  .header-right {
    padding-left: 20px;
  }
  .header-right p {
    color: #A0A2A3;
    line-height: 20px;
  }
  .se-panel-title {
    font-size: 16px;
  }
  .goodness {
    margin-bottom: 50px;
  }
  .goodness .grid-content {
    min-height: 224px;
    border: 1px solid #eee;
    border-right: 0;
  }
  .goodness .el-row:last-child {
     border-right: 1px solid #eee;
   }
  .goodness-icon {
    width: 69px;
    height: 53px;

  }
  .icon-01 {
    background: url(../../assets/imgs/goodness_01.png) no-repeat;
  }
  .icon-02 {
    background: url(../../assets/imgs/goodness_02.png) no-repeat;
  }
  .icon-03 {
    background: url(../../assets/imgs/goodness_03.png) no-repeat;
  }
  .icon-04 {
    background: url(../../assets/imgs/goodness_04.png) no-repeat;
  }
  .freevhost-help {
    margin-top: 20px;
    padding: 15px;
    border: 1px solid #eee;
    margin-bottom: 20px;
  }
  .notice-list-panel {
    padding: 5px 18px;
  }
  .notice-list-panel li:first-child {
    border-top: none;
  }
  .notice-list-panel li {
    line-height: 3.3rem;
    border-top: 1px dashed #eee;
  }
  .row-border { border-bottom: 1px solid #eee; }
  .freevhost-table {
    border-right: 1px solid #eee;
  }
  .freevhost-table .grid-content {
    line-height: 40px;
  }
  .freevhost-table .grid-content-left {
    background-color: #f7f9fb;
    border-left: 1px solid #eee;
    border-right: 1px solid #eee;
  }
  .grid-content-small {
    line-height: 35px;
  }

  .dialogShadow{position:fixed;z-index:9900;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.5);}
  .dialogBody{position:fixed;z-index:9909;top:37%;left:50%;transform:translateX(-50%);min-width:32rem;background:#fff;box-shadow: 0 0 10px 3px rgba(0,0,0,.2);animation:dialogAnimStart .2s forwards}
  .dialogTitle{position:relative;padding:1rem 0;background:#f7f9fa;color:#636566;}
  .dialogContent{padding: 2rem 2rem 2rem 0}
  .dialogFooter{background:#f7f9fa;}
  @keyframes dialogAnimEnd{
    from{opacity:1}
    to{opacity:0}
  }
  .aui_close {
    position: absolute;
    padding: 0;
    top: 31%;
    right: 22px;
    width: 21px;
    height: 21px;
    line-height: 21px;
    font-size: 30px;
    color: #636566;
    text-align: center;
    font-family: Helvetica, STHeiti;
  }
</style>



// WEBPACK FOOTER //
// src/pages/product/freeVhostList.vue